<template>
<div>
    <div id="hr_root_div">
        <div id="hr_sport_section">
            <div id="sport_hr_title">
                <div class="bluebar" style="margin-right: 10px;"></div>
                <div class="title_text">{{ $t("message")["HeartRate.sporthr"] }}</div>
            </div>
            <div id="sport_area_chart"></div>
        </div>
        <div id="abnormal_hr_section">
            <div id="sport_hr_title">
                <div class="bluebar" style="margin-right: 10px;"></div>
                <div class="title_text">{{ $t("message")["HeartRate.abnormal"] }}</div>
            </div>
            <a-table :columns="columns" :dataSource="abnormalHrList" :rowKey="key" :show-header="false">
                <template slot="time-column" slot-scope="time">
                    <div class="horizontal_area">
                        <div class="red_circle"></div>
                        <div class="content1">您有1条异常数据</div>
                    </div>
                    <div class="content2">{{time}}</div>
                </template>
                <template slot="hr-column" slot-scope="value">
                    <div class="content3">最高心率</div>
                    <div class="content4">{{value}}bpm</div>
                </template>                
            </a-table>
        </div>
    </div>
</div>
</template>

<script>
import echarts from 'echarts';
export default {
    name: "HeartRateSportAnalyzeData",
    props: [
        "minutesList",
        "abnormalHrList"
    ],
    data() {
        return {
            columns: [
                { title: this.$t("message")['AtrialData.time'], dataIndex: 'time', scopedSlots: { customRender: "time-column" } },
                { title: this.$t("message")['HealthHome.hr'], dataIndex: 'value', scopedSlots: { customRender: "hr-column" } },
            ]
        };
    },        
    methods: {
        drawChart() {
            var dom = document.getElementById("sport_area_chart");
            var myChart = echarts.init(dom);
            myChart.setOption({                               
            tooltip: {
                trigger: 'item'
            },
            legend: {
                bottom: '0',
                left: 'center'
            },
            series: [
            {
                name: '运动心率',
                type: 'pie',
                radius: ['40%', '60%'],
                avoidLabelOverlap: false,
                itemStyle: {
                    borderRadius: 10,
                    borderColor: '#fff',
                    borderWidth: 2
                },
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                    show: true,
                    fontSize: 40,
                    fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: this.minutesList[0], name: this.$t("message")['HeartRate.range_normal'], itemStyle: { color: '#00BC98' } },
                    { value: this.minutesList[1], name: this.$t("message")['HeartRate.range_warmup'], itemStyle: { color: '#0286FF' } },
                    { value: this.minutesList[2], name: this.$t("message")['HeartRate.range_burnfat'], itemStyle: { color: '#20FEF5' } },
                    { value: this.minutesList[3], name: this.$t("message")['HeartRate.range_aerobic'], itemStyle: { color: '#8E80F2' } },
                    { value: this.minutesList[4], name: this.$t("message")['HeartRate.range_anaerobic'], itemStyle: { color: '#FE9B52' } },
                    { value: this.minutesList[5], name: this.$t("message")['HeartRate.range_extreme'], itemStyle: { color: '#FE6B87' } }
                ]
            }        
            ]
            });
        }       
    },
    mounted(){
        console.log('minutesList:',this.minutesList);
        this.drawChart();
    }
}
</script>

<style scoped>
#hr_root_div {
    display: flex;
    justify-content: space-around;
    height: 300px;
}

#hr_sport_section {
    width: 490px;
}

#abnormal_hr_section {
    width: calc(100% - 560px);
}

#sport_hr_title {
    display: flex;
    align-items: center;
    margin-top: 20px;
} 

.bluebar {
    width: 4px;
    height: 13px;
    background-color: #2284FF;
}

.title_text {
    color: #292929;
    font-size: 15px;
    font-family: PingFang SC-Medium;
}

#sport_area_chart {
    width: 100%;
    height: 300px;
}

.content1 {
    color: #707070;
    font-size: 12px;
}

.content2 {
    color: #393939;
    font-size: 14px;
}

.content3 {
    color: #707070;
    font-size: 12px;
}

.content4 {
    color: #FC6C87;
    font-size: 14px;
}

.red_circle {
    width: 6px;
    height: 6px;
    background-color: red;
    border-radius: 50%;
    margin-right: 6px;
}

.horizontal_area {
    display: flex;
    align-items: center;
}
</style>